
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  id: 'f07d7953e8',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=home><div class="navbar no-hairline"><div class=navbar-bg></div><div class="navbar-inner sliding text-align-center"><div class=left></div><div class="title titulo-tela-historico">Leituras Realizadas</div><div class=right></div></div></div><!-- Toolbar--><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=col-10></div><a href=javascript:; class="col-20 link button button-fill button-rounded btnLerCodigo p-2"><i class="fas fa-2x fa-qrcode"></i></a> <a href=/codigo/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-ticket-alt"></i></a> <a href=/leituras/ class="col-20 link button button-fill button-rounded p-2 active"><i class="fas fa-2x fa-list"></i></a> <a href=/logout/ class="col-20 link button button-fill button-rounded p-2"><i class="fas fa-2x fa-sign-out-alt"></i></a><div class=col-10></div></div></div><!-- Scrollable page content--><div class=page-content><div class=block><div class="list media-list p-0 m-0 lista-veiculos">';
      r += Template7Helpers.each.call(ctx_1, ctx_1.leituras, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=/codigo/';
          r += c(ctx_2.codigo, ctx_2);
          r += '/ ><div style="background-color: #FFF; margin-bottom: 1px; color: #5c5c5c; padding: 4px;"><div class=item-title><b>';
          r += c(ctx_2.nome, ctx_2);
          r += '</b></div><div><small><i>';
          r += c(ctx_2.codigo, ctx_2);
          r += ' - ';
          r += c(ctx_2.codigo_externo, ctx_2);
          r += '</i></small></div>Telefone: ';
          r += c(ctx_2.celular, ctx_2);
          r += '<br>E-mail: ';
          r += c(ctx_2.email, ctx_2);
          r += '<div>Perfil: ';
          r += c(ctx_2.perfil, ctx_2);
          r += '</div><div>Data do Evento: ';
          r += c(ctx_2.dataEvento, ctx_2);
          r += '</div><div><small><i>lido em ';
          r += c(ctx_2.data, ctx_2);
          r += '</i></small></div></div></a>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><hr><a href=';
      r += c(ctx_1.link_exportacao, ctx_1);
      r += ' target=_system class="button button-fill button-xs button-rounded external">EXPORTAR</a><hr><div class=text-align-center><small><small>Lembre-se: os dados acima são protegidos pela LGPD. Ao fazer a leitura, o visitante está concedendo direito para a sua empresa, devidamente cadastrada a ter acesso aos seus dados. Não compartilhe, divulgue ou comercialize os dados coletados, sob pena de exclusão ou multa por parte das autoridades.</small></small></div><br></div></div></div>';
      return r;
    }(this);
  },
  styleScoped: false
};
    